export default {"src":"https://fishbrain.com/_next/static/media/wyoming.3f587ba7.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};